import VueRouter from 'vue-router'

import Login from '@/views/Login'
import NotFound from '@/views/404'
import Home from '@/views/Home'

const getView = view => require(`@/views/${view}`).default

let routes = [
  {
    path: '/login',
    component: Login,
    name: 'Login',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/404',
    component: NotFound,
    name: '404',
    hidden: true,
    meta: {
      guests: true
    }
  },
  //{ path: '/main', component: Main },
  {
    path: '/',
    component: Home,
    name: 'Home',
    iconCls: 'el-icon-star-on',
    meta: { label: 'Home' },
    redirect: {
      name: 'Dashboard'
    },
    hidden: true
  },
  {
    path: '/dashboard',
    component: Home,
    iconCls: 'el-icon-s-home',
    meta: { label: 'Dashboard' },
    children: [
      {
        path: '',
        component: getView('Dashboard/Dashboard'),
        name: 'Dashboard',
        iconCls: 'el-icon-star-on',
        meta: { label: 'Home' }
      }
    ]
  },
  {
    path: '/separator',
    separator: true,
    meta: { label: 'Blog' }
  },
  {
    path: '/articles/items',
    component: Home,
    iconCls: 'fa fa-newspaper-o',
    meta: { label: 'Artykuły' },
    children: [
      {
        path: '',
        component: getView('Articles/ArticleList'),
        name: 'Article List',
        meta: { label: 'Lista artykułów' }
      },
      {
        path: 'add',
        component: getView('Articles/ArticleForm'),
        name: 'Add Article',
        meta: { label: 'Dodaj artykuł' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Articles/ArticleForm'),
        name: 'Edit Article',
        hidden: true,
        meta: { label: 'Edytuj artykuł' }
      }
    ]
  },
  {
    path: '/articles/categories',
    component: Home,
    iconCls: 'fa fa-paperclip',
    meta: { label: 'Artykuły - kategorie' },
    children: [
      {
        path: '',
        component: getView('ArticleCategories/ArticleCategoryList'),
        name: 'Article Category List',
        meta: { label: 'Lista kategorii' }
      },
      {
        path: 'add',
        component: getView('ArticleCategories/ArticleCategoryForm'),
        name: 'Add Article Category',
        meta: { label: 'Dodaj kategorię' }
      },
      {
        path: ':id',
        props: true,
        component: getView('ArticleCategories/ArticleCategoryForm'),
        name: 'Edit Article Category',
        hidden: true,
        meta: { label: 'Edytuj kategorię' }
      }
    ]
  },
  {
    path: '/articles/tags',
    component: Home,
    iconCls: 'fa fa-hashtag',
    meta: { label: 'Artykuły - tagi' },
    children: [
      {
        path: '',
        component: getView('ArticleTags/ArticleTagList'),
        name: 'ArticleTag List',
        meta: { label: 'Lista tagów' }
      },
      {
        path: 'add',
        component: getView('ArticleTags/ArticleTagForm'),
        name: 'Add ArticleTag',
        meta: { label: 'Dodaj tag' }
      },
      {
        path: ':id',
        props: true,
        component: getView('ArticleTags/ArticleTagForm'),
        name: 'Edit ArticleTag',
        hidden: true,
        meta: { label: 'Edytuj tag' }
      }
    ]
  },
  {
    path: '/separator',
    separator: true,
    meta: { label: 'Podcasts' }
  },
  {
    path: '/podcasts/items',
    component: Home,
    iconCls: 'fa fa-newspaper-o',
    meta: { label: 'Podcasty' },
    children: [
      {
        path: '',
        component: getView('Podcasts/PodcastList'),
        name: 'Podcast List',
        meta: { label: "Lista podcast'ów" }
      },
      {
        path: 'add',
        component: getView('Podcasts/PodcastForm'),
        name: 'Add Podcast',
        meta: { label: 'Dodaj podcast' }
      },
      {
        path: 'listing',
        component: getView('Podcasts/PodcastListingForm'),
        name: 'Podcasts List Page',
        meta: { label: 'Strona listy podcastów' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Podcasts/PodcastForm'),
        name: 'Edit Podcast',
        hidden: true,
        meta: { label: 'Edytuj podcast' }
      }
    ]
  },
  {
    path: '/podcasts/categories',
    component: Home,
    iconCls: 'fa fa-paperclip',
    meta: { label: 'Podcast - kategorie' },
    children: [
      {
        path: '',
        component: getView('PodcastCategories/PodcastCategoryList'),
        name: 'Podcast Category List',
        meta: { label: 'Lista kategorii' }
      },
      {
        path: 'add',
        component: getView('PodcastCategories/PodcastCategoryForm'),
        name: 'Add Podcast Category',
        meta: { label: 'Dodaj kategorię' }
      },
      {
        path: ':id',
        props: true,
        component: getView('PodcastCategories/PodcastCategoryForm'),
        name: 'Edit Podcast Category',
        hidden: true,
        meta: { label: 'Edytuj kategorię' }
      }
    ]
  },
  {
    path: '/separator',
    separator: true,
    meta: { label: 'Narzędzia dla kultury' }
  },
  {
    path: '/tools/categories',
    component: Home,
    iconCls: 'fa fa-th-large',
    meta: { label: 'Kategorie' },
    children: [
      {
        path: '',
        component: getView('Tools/CategoryList'),
        name: 'Category List',
        meta: { label: 'Lista kategorii' }
      },
      {
        path: 'add',
        component: getView('Tools/CategoryForm'),
        name: 'Add Category',
        meta: { label: 'Dodaj kategorię' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Tools/CategoryForm'),
        name: 'Edit Category',
        hidden: true,
        meta: { label: 'Edytuj kategorię' }
      }
    ]
  },
  {
    path: '/tools/suggestions',
    component: Home,
    iconCls: 'fa fa-wpforms',
    meta: { label: 'Sugestie' },
    children: [
      {
        path: '',
        component: getView('Tools/SuggestionList'),
        name: 'Suggestion List',
        meta: { label: 'Lista sugestii' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Tools/SuggestionForm'),
        name: 'Edit Suggestion',
        hidden: true,
        meta: { label: 'Edytuj sugestię' }
      }
    ]
  },
  {
    path: '/separator',
    separator: true,
    meta: { label: 'Treść' }
  },
  {
    path: '/pages',
    component: Home,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Podstrony' },
    children: [
      {
        path: '',
        component: getView('Pages/PagesList'),
        name: 'Pages List',
        meta: { label: 'Lista stron' }
      },
      {
        path: 'add',
        component: getView('Pages/PageForm'),
        name: 'Add Page',
        meta: { label: 'Dodaj stronę' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Pages/PageForm'),
        name: 'Edit Page',
        hidden: true,
        meta: { label: 'Edytuj stronę' }
      }
    ]
  },
  {
    path: '/separator',
    separator: true,
    meta: { label: 'Pliki' }
  },
  {
    path: '/images',
    component: Home,
    iconCls: 'fa fa-image',
    meta: { label: 'Zdjęcia' },
    children: [
      {
        path: '',
        component: getView('Image/ImageList'),
        name: 'Image List',
        meta: { label: 'Lista zdjęć' }
      },
      {
        path: 'add',
        component: getView('Image/ImageForm'),
        name: 'Add Image',
        meta: { label: 'Dodaj zdjęcie' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Image/ImageForm'),
        name: 'Edit Image',
        hidden: true,
        meta: { label: 'Edytuj zdjęcie' }
      }
    ]
  },
  {
    path: '/videos',
    component: Home,
    iconCls: 'fa fa-video-camera',
    meta: { label: 'Wideo' },
    children: [
      {
        path: '',
        component: getView('Video/VideoList'),
        name: 'Video List',
        meta: { label: 'Lista wideo' }
      },
      {
        path: 'add',
        component: getView('Video/VideoForm'),
        name: 'Add Video',
        meta: { label: 'Dodaj wideo' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Video/VideoForm'),
        name: 'Edit Video',
        hidden: true,
        meta: { label: 'Edytuj wideo' }
      }
    ]
  },
  {
    path: '/attachments',
    component: Home,
    iconCls: 'fa fa-download',
    meta: { label: 'Załączniki' },
    children: [
      {
        path: '',
        component: getView('Attachments/AttachmentsList'),
        name: 'Attachments List',
        meta: { label: 'Lista załączników' }
      }
    ]
  },
  {
    path: '/separator',
    separator: true,
    meta: { label: 'Konfiguracja Strony' }
  },
  {
    path: '/menu',
    component: Home,
    iconCls: 'fa fa-bars',
    meta: { label: 'Menu' },
    children: [
      {
        path: '',
        component: getView('Menus/MenusList'),
        name: 'Menus List',
        meta: { label: 'Lista menu' },
        hidden: true
      },
      {
        path: 'main-menu',
        props: {
          default: true,
          id: 'main-menu'
        },
        component: getView('Menus/MenuForm'),
        name: 'Edit Menu',
        meta: { label: 'Edytuj menu główne' }
      }
    ]
  },
  {
    path: '/users',
    component: Home,
    iconCls: 'fa fa-group',
    meta: { label: 'Użytkownicy' },
    children: [
      {
        path: '',
        component: getView('User/UserList'),
        name: 'User List',
        meta: { label: 'Lista użytkowników' }
      },
      {
        path: 'add',
        component: getView('User/UserForm'),
        name: 'Add User',
        meta: { label: 'Dodaj użytkownika' }
      },
      {
        path: ':id',
        props: true,
        component: getView('User/UserForm'),
        name: 'Edit User',
        hidden: true,
        meta: { label: 'Edytuj użytkownika' }
      }
    ]
  },
  {
    path: '/settings',
    component: Home,
    iconCls: 'fa fa-cog',
    meta: { label: 'Ustawienia' },
    children: [
      {
        path: '',
        component: getView('Settings/SettingsForm'),
        name: 'Settings Form',
        meta: { label: 'Konfiguracja strony' }
      }
    ]
  },
  {
    path: '/contact-forms',
    component: Home,
    iconCls: 'fa fa-envelope',
    meta: { label: 'Zapytania' },
    children: [
      {
        path: '',
        component: getView('ContactForms/ContactFormList'),
        name: 'Contact Form List',
        meta: { label: 'Lista zapytań' }
      },
      {
        path: ':id',
        props: true,
        component: getView('ContactForms/ContactForm'),
        name: 'View Contact Form',
        hidden: true,
        meta: { label: 'Przeglądaj zapytanie' }
      }
    ]
  },
  {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isUserLoggedIn = window.localStorage.getItem('token')
  if (!to.meta.guests && !isUserLoggedIn) {
    next({ name: 'Login', query: { next: to.path } })
    return
  }
  document.title = to.meta.label
    ? `${to.meta.label} - p-programisci - admin`
    : 'p-programisci - admin'
  next()
})

export default router
